import React, { Suspense, lazy, useState, useEffect } from 'react';
import { Routes, Route, Link, Switch } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import { useLocation } from 'react-router';

import Particles from 'react-tsparticles';

import {
    Backdrop,
    Navbar,
    Cursor,
    // Particles as particlesOptions,
} from './components';

import { Home, LightMap, ModelViewer, AnimatedPage } from './containers';
import './App.css';

const App = () => {
    const location = useLocation();

    return (
        <div>
            <Backdrop />
            <Navbar />
            <Cursor />
            {/* <Particles style={{ zindex: '10' }} options={particlesOptions} /> */}
            <AnimatePresence>
                <Routes
                    key={location.pathname}
                    location={location}
                >
                    <Route
                        exact
                        path='/'
                        element={
                            <AnimatedPage>
                                <Home />
                            </AnimatedPage>
                        }
                    />
                    {/* <Route
						path="/about"
						element={
							<AnimatedPage>
								<About />
							</AnimatedPage>
						}
					/> */}
                    {/* <Route
						path="/contact"
						element={
							<AnimatedPage>
								<Contact />
							</AnimatedPage>
						}
					/> */}
                    <Route
                        path='/lightpollutionmap'
                        element={
                            <AnimatedPage>
                                <LightMap />
                            </AnimatedPage>
                        }
                    />
                    <Route
                        path='/modelviewer'
                        element={
                            <AnimatedPage>
                                <ModelViewer />
                            </AnimatedPage>
                        }
                    />
                </Routes>
            </AnimatePresence>
        </div>
    );
};

export default App;
